import { render } from "./EtapaView.vue?vue&type=template&id=e40ffdf2&scoped=true"
import script from "./EtapaView.vue?vue&type=script&lang=js"
export * from "./EtapaView.vue?vue&type=script&lang=js"

import "./EtapaView.vue?vue&type=style&index=0&id=e40ffdf2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e40ffdf2"]])

export default __exports__